import React, { useContext } from 'react';
import ServerContext from '../../../contexts/serverContext';
import { CategoriesProps } from './hook/use-bbt-content';
import { Link } from '../../../components/common';
import { useRouterLocation } from '../../../hooks/use-router-location';
import { useBbtCategories } from './hook/use-bbt-categories';
import { BRAND } from '../../../constants';
import { useAnalytics } from '../../../hooks/use-analytics';
import './browse-by-topic.scss';
import { ASTUTE } from '../../support-constants';
import ServerSideService from '../../../services/server-side-service/server-side-service';

interface Props {
    bbtContent: CategoriesProps | null;
    analyticsClickEventName?: string;
}

const BrowseByTopic = (props: Props) => {
    const [fireEvents] = useAnalytics();
    const { bbtContent } = props;
    const serverContext = useContext(ServerContext);
    const displayCategories: {
        url: string;
        iconPath: string;
        categoryName: string | undefined;
    }[] = [];
    const currentRoot = serverContext.root
        ? serverContext.root.substring(0, serverContext.root.length - 1)
        : '';
    const defaultIconPath =
        serverContext.brand === BRAND.ford.LONG_NAME
            ? 'icons/bbt-desktop-default-icon.svg'
            : 'icons/bbt-desktop-default-lincoln-icon.svg';
    const location = useRouterLocation();
    const curPathName = ServerSideService.isClientSide()
        ? filterXSS(location.pathname)
        : null;

    const bbtCategories = useBbtCategories(
        serverContext.currentLanguageRegionCode,
        serverContext.brand
    );

    const hideSearchBar = ASTUTE.DOMAINS_TO_SKIP_BBT_SEARCH.includes(
        serverContext.domain
    );
    bbtContent?.categories?.forEach(contentCateg => {
        const categoryIcon = bbtCategories?.find(
            cat => parseInt(contentCateg.category) === cat.categoryId
        );
        const url = `${currentRoot}${categoryIcon?.categoryAbsoluteSeo}`;
        const iconPath = contentCateg?.categoryDesktopIcon
            ? `${process.env.REACT_APP_AEM_BASE_URL +
                  contentCateg?.categoryDesktopIcon}`
            : defaultIconPath;
        categoryIcon &&
            displayCategories.push({
                url: url,
                iconPath: iconPath,
                categoryName: categoryIcon?.categoryName,
            });
    });
    bbtCategories?.forEach(element => {
        if (
            displayCategories.findIndex(
                dispCateg => dispCateg.categoryName === element.categoryName
            ) < 0
        ) {
            const url = `${currentRoot}${element?.categoryAbsoluteSeo}`;
            displayCategories.push({
                url: url,
                iconPath: defaultIconPath,
                categoryName: element?.categoryName,
            });
        }
    });

    return bbtContent &&
        bbtCategories &&
        !bbtContent.hideBrowseByTopic &&
        !hideSearchBar ? (
        <div id="bbt">
            <h2 className="bbt-title">
                <Link
                    className="section-heading-link"
                    href={`${curPathName}#bbt`}
                    role="presentation"
                    tabIndex={-1}
                >
                    {bbtContent.titleWithDisclaimer || bbtContent.title}
                </Link>
            </h2>
            <p className="bbt-subtitle">
                {bbtContent.subTitleWithDisclaimer || bbtContent.subTitle}
            </p>
            <ul className="categories">
                {displayCategories?.map(categ => {
                    return (
                        <li key={categ.url} className="categories-list">
                            <a
                                className="category-link"
                                href={categ.url}
                                onClick={() => {
                                    props.analyticsClickEventName &&
                                        fireEvents(
                                            props.analyticsClickEventName,
                                            undefined,
                                            {
                                                smashHomeClick: {
                                                    bbtCategoryName:
                                                        categ.categoryName,
                                                },
                                            },
                                            false
                                        );
                                }}
                            >
                                <img
                                    loading="lazy"
                                    src={categ.iconPath}
                                    alt=""
                                    className="category-icon"
                                ></img>
                                <p className="category-name">
                                    {categ.categoryName}
                                </p>
                            </a>
                        </li>
                    );
                })}
            </ul>
        </div>
    ) : (
        <></>
    );
};
export default BrowseByTopic;
